import * as commonFields from "./common-fields";
import type { BaseLineDto } from "@ckweb/ckfetch/connectables/equipmentAreaManagement";

type ProductionLineDataItem = BaseLineDto & {
  number?: number;
};

export const productionLineSchema: $ck.z.ZodType<ProductionLineDataItem> =
  $ck.z.object({
    number: commonFields.optionalNumberField(),
    name: commonFields.requiredStringField(),
    location: commonFields.stringOrEmptyField(),
    dateInstalled: commonFields.stringDateOrNullField(),
    active: commonFields.booleanField(),
    gmp: commonFields.booleanField(),
    comments: commonFields.stringOrEmptyField(),
  });

export type ProductionLineSchema = $ck.z.TypeOf<typeof productionLineSchema>;
